import Loader from '@anm/components/Loader';
import { FC } from 'react';

import { CurrentPlanLoaderWrapper } from './Wrapper';

type CurrentPlanLoaderProps = {};

const CurrentPlanLoader: FC<CurrentPlanLoaderProps> = () => (
  <CurrentPlanLoaderWrapper>
    <Loader color="blue" size="large" />
  </CurrentPlanLoaderWrapper>
);

export default CurrentPlanLoader;
